const crisp = () => {
  const win = window as any;
  if (!win.$crisp) {
    win.$crisp = [];
  }
  return win.$crisp;
};
export const hideCrisp = () => {
  crisp().push(['do', 'chat:hide']);
};

export const showCrisp = () => {
  crisp().push(['do', 'chat:show']);
};

export const reverseCrisp = (reverse: boolean) => {
  crisp().push(['config', 'position:reverse', reverse]);
};

export const openCrisp = () => {
  crisp().push(['do', 'chat:open']);
};

export const CRISP_Z_INDEX = 1000000;
